import Dropdown from './dropdown';

window.addEventListener('resize', function (e) {
  setTimeout(() => {
    console.log(window.innerWidth);
  }, 0);
});

document.addEventListener('DOMContentLoaded', function () {
  const sliderMain = new Swiper('.slider-main', {
    rewind: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 5000,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const sliderAdvantages = new Swiper('.slider-advantages', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: 700,

    breakpoints: {
      576: {
        spaceBetween: 20,
      },

      1280: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });

  const sliderCat = new Swiper('.slider-cat', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    observer: true,

    breakpoints: {
      576: {},

      992: {
        spaceBetween: 20,
        slidesPerView: 4,

        grid: {
          fill: 'row',
          rows: 3,
        },
      },

      1200: {
        spaceBetween: 24,
        slidesPerView: 4,

        grid: {
          fill: 'row',
          rows: 3,
        },
      },
    },
  });

  const sliderRent = new Swiper('.slider-rent', {
    slidesPerView: 'auto',
    spaceBetween: 16,

    breakpoints: {
      576: {
        spaceBetween: 20,
      },

      1280: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });

  const sliderFirms = new Swiper('.slider-firms', {
    rewind: false,
    slidesPerView: 'auto',
    spaceBetween: 4,
    watchSlidesProgress: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      576: {},

      1280: {},
    },
  });

  const sliderThumbs = new Swiper('.sliderThumbs', {
    spaceBetween: 16,
    slidesPerView: 4,
    rewind: true,
    watchSlidesProgress: true,
  });

  const sliderThumbs2 = new Swiper('.sliderThumbs2', {
    spaceBetween: 16,
    effect: 'fade',
    watchSlidesProgress: true,

    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 5000,
    },

    thumbs: {
      swiper: sliderThumbs,
    },
  });

  const sliderThumbsSingle = new Swiper('.sliderThumbsSingle', {
    spaceBetween: 16,
    slidesPerView: 4,
    rewind: true,
    watchSlidesProgress: true,
  });

  const sliderThumbs2Single = new Swiper('.sliderThumbs2Single', {
    spaceBetween: 16,
    effect: 'fade',
    watchSlidesProgress: true,

    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 5000,
    },

    thumbs: {
      swiper: sliderThumbsSingle,
    },
  });

  if (document.querySelector('[data-flip-trigger]')) {
    startFlipTrigger();
  }

  if (document.querySelector('[data-arr-top]')) {
    startArrTop();
    addFooterObserver(document.querySelector('#footer'));
  }

  if (document.querySelector('[data-btn-trigger-nav]')) {
    document
      .querySelector('[data-btn-trigger-nav]')
      .addEventListener('click', toggleNavMenu);
  }

  if (document.querySelector('#header')) {
    document
      .querySelector('#header')
      .addEventListener('click', headerClickHandler);
  }

  if (document.querySelector('[data-form-filter]')) {
    document.querySelector('[data-form-filter]').reset();
  }

  if (document.querySelector('[data-dropdown]')) {
    window.dropdowns = [];

    document.querySelectorAll('[data-dropdown]').forEach((el) => {
      window.dropdowns.push(new Dropdown(el));
    });
  }

  if (document.querySelector('.card-tool__wrap-img')) {
    document.querySelectorAll('.card-tool__wrap-img').forEach((el) => {
      el.addEventListener('click', toolPreviewHandler);
    });
  }

  if (document.querySelector('#map')) {
    setTimeout(() => {
      addMapScripts();
    }, 3000);
  }

  if (document.querySelector('[data-form-filter]')) {
    document
      .querySelector('[data-form-filter]')
      .addEventListener('change', updateFilterHandler);
  }

  if (document.querySelector('[data-alltools]')) {
    document.querySelector('[data-alltools]').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('[data-cards-list]').classList.remove('dn');
      document.querySelector('.slider-cat').classList.add('dn');
    });
  }

  document.addEventListener('click', clickAnyWhere);
  createScrollbarWidth();
});

function updateFilterHandler(e) {
  console.log(e.target.value);

  const filterEl = document.querySelector('[data-form-filter]');
  const dropdownAction = filterEl.querySelector('[data-dropdown=action]');
  const dropdownName = filterEl.querySelector('[data-dropdown=name]');
  const cardsListEl = document.querySelector('[data-cards-list]');
  const sliderEl = document.querySelector('.slider-cat');
  const cardsListElsArr = cardsListEl.querySelectorAll('.card-tool__wrap-img');

  // Сброс вручную текста внутри кнопки
  if (e.target.name === 'tool-action') {
    const triggerBtn = dropdownName.querySelector('[data-dropdown-toggle]');
    triggerBtn.querySelector('[data-dropdown-toggle-text]').innerText =
      triggerBtn.dataset.default;

    if (dropdownName.querySelector('input[name=tool-name]:checked')) {
      dropdownName.querySelector(
        'input[name=tool-name]:checked'
      ).checked = false;
    }

    cardsListElsArr.forEach((element) => {
      const tagsDirty = element.dataset.tags.split(';');
      const tags = [];
      tagsDirty.forEach((item) => tags.push(item.trim()));

      if (tags.includes(e.target.value)) {
        element.closest('[data-card-parent]').classList.remove('dn');
      } else {
        element.closest('[data-card-parent]').classList.add('dn');
      }
    });
  } else if (e.target.name === 'tool-name') {
    const triggerBtn = dropdownAction.querySelector('[data-dropdown-toggle]');
    triggerBtn.querySelector('[data-dropdown-toggle-text]').innerText =
      triggerBtn.dataset.default;

    if (dropdownAction.querySelector('input[name=tool-action]:checked')) {
      dropdownAction.querySelector(
        'input[name=tool-action]:checked'
      ).checked = false;
    }

    cardsListElsArr.forEach((element) => {
      const namesDirty = element.dataset.names.split(';');
      const names = [];
      namesDirty.forEach((item) => names.push(item.trim()));

      if (names.includes(e.target.value)) {
        element.closest('[data-card-parent]').classList.remove('dn');
      } else {
        element.closest('[data-card-parent]').classList.add('dn');
      }
    });
  }

  cardsListEl.classList.remove('dn');
  sliderEl.classList.add('dn');
}

function toolPreviewHandler(e) {
  console.log(this);
  const thisEl = this;
  const targetSliderSelector = e.currentTarget.dataset.popuptrigger;
  const targetSlider = document.querySelector(targetSliderSelector);
  const targetSliderCard = targetSlider.querySelector('.tool');
  const cardTitleEl = targetSliderCard.querySelector('.tool__title');
  const cardPriceEl = targetSliderCard.querySelector('.tool__price');
  const cardSpecificationsEl = targetSliderCard.querySelector(
    '.tool__details.specifications'
  );
  const cardInStockEl = targetSliderCard.querySelector(
    '.tool__details.instock'
  );
  const cardLinkEl = targetSliderCard.querySelector('.tool__link');
  const cardSliderImgs = targetSliderCard.querySelectorAll(
    '.sliderThumbs2 img'
  );
  const cardSliderSlides = targetSliderCard.querySelectorAll(
    '.sliderThumbs2 .swiper-slide'
  );
  const cardSliderImgsWrapper = targetSliderCard.querySelector(
    '.sliderThumbs2 .swiper-wrapper'
  );
  const cardSliderThumbsImgs = targetSliderCard.querySelectorAll(
    '.sliderThumbs img'
  );
  const cardSliderThumbsSlides = targetSliderCard.querySelectorAll(
    '.sliderThumbs .swiper-slide'
  );
  const cardSliderThumbsImgsWrapper = targetSliderCard.querySelector(
    '.sliderThumbs .swiper-wrapper'
  );

  cardTitleEl.innerText = thisEl.dataset.title || 'Заголовок не обнаружен';
  cardPriceEl.innerText = thisEl.dataset.price || '?';
  cardLinkEl.href = thisEl.href;

  cardSpecificationsEl.innerHTML = '';
  const listDetails = thisEl.dataset.details.split(';');
  listDetails.forEach((item) => {
    const detailArr = item.split('|');
    const li = document.createElement('li');
    li.classList.add('tool__details-item');
    li.innerHTML = `<span>${detailArr[0] || ''}</span><span>${
      detailArr[1] || ''
    }</span>`;
    cardSpecificationsEl.appendChild(li);
  });

  cardInStockEl.innerHTML = '';
  const listDetailsInStock = thisEl.dataset.instock.split(';');
  listDetailsInStock.forEach((item) => {
    const detailArr = item.split('|');
    const li = document.createElement('li');
    li.classList.add('tool__details-item');
    li.innerHTML = `<span>${detailArr[0] || ''}</span><span>${
      detailArr[1] || ''
    }</span>`;
    cardInStockEl.appendChild(li);
  });

  cardSliderImgsWrapper.innerHTML = '';
  cardSliderThumbsImgsWrapper.innerHTML = '';
  const listImgsUrls = thisEl.dataset.imgs.split(';');
  listImgsUrls.forEach((item, i) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.src = item;
    slide.appendChild(img);
    cardSliderImgsWrapper.appendChild(slide);
  });
  listImgsUrls.forEach((item, i) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.src = item;
    slide.appendChild(img);
    cardSliderThumbsImgsWrapper.appendChild(slide);
  });
}

function makeToolDetailsItem(str1, str2 = '') {
  const toolDetailsItemEl = document.createElement('li');
  toolDetailsItemEl.classList.add('tool__details-item');
  toolDetailsItemEl.innerHTML = `<span>${str1}</span><span>${str2}</span>`;
  return toolDetailsItemEl;
}

function createScrollbarWidth() {
  const html = document.querySelector('html');
  const scrollDiv = document.createElement('div');
  scrollDiv.style.cssText =
    'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
  document.body.appendChild(scrollDiv);
  const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  html.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
}

function clickAnyWhere(e) {
  const closestDropdown = e.target.closest('[data-dropdown]');

  if (!closestDropdown) {
    document.querySelectorAll('[data-dropdown]').forEach((el) => {
      el.classList.remove('active');
    });
  } else {
    document.querySelectorAll('[data-dropdown]').forEach((el) => {
      if (closestDropdown !== el) {
        el.classList.remove('active');
      }
    });
  }
}

function toggleNavMenu(e) {
  if (e) {
    e.stopPropagation();
  }
  document.querySelector('[data-btn-trigger-nav]').classList.toggle('active');
  document.querySelector('#header').classList.toggle('active');
}

function headerClickHandler() {
  if (
    !window.matchMedia('(min-width: 992px)').matches &&
    document.querySelector('[data-btn-trigger-nav].active')
  ) {
    // mobile
    toggleNavMenu();
  }
}

function startFlipTrigger() {
  document.querySelectorAll('[data-flip-trigger]').forEach((el) => {
    el.addEventListener('click', (e) => {
      if (!window.matchMedia('(min-width: 992px)').matches) {
        e.currentTarget.closest('.swiper-slide').classList.toggle('flip');
      }
    });
  });
}

function startArrTop() {
  const arrTopEl = document.querySelector('[data-arr-top]');

  window.addEventListener('scroll', arrTopPos, false);
  arrTopDefaultStyles(arrTopEl);

  window.addEventListener('resize', () => {
    setTimeout(() => {
      if (window.arrTopStickToFooter) {
        arrTopFooterStyles(arrTopEl);
      } else {
        arrTopDefaultStyles(arrTopEl);
      }
    }, 0);
  });
}

function arrTopPos() {
  const arrTopEl = document.querySelector('[data-arr-top]');
  const offsetTriggerToShowArr = window.innerHeight * 1.5;

  if (window.pageYOffset > offsetTriggerToShowArr) {
    arrTopEl.classList.add('show');
  } else if (arrTopEl.classList.contains('show')) {
    arrTopEl.classList.remove('show');
  }
}

function arrTopDefaultStyles(el) {
  el.style.top = '100vh';
  el.style.position = 'fixed';
  el.style.right = 'initial';
  el.style.left = '50%';
  el.style.transform = `translate(${getArrTopLeftShift()}px, -130%)`;
}

function arrTopFooterStyles(el) {
  el.style.top = document.querySelector('#footer').offsetTop - 70 + 'px';
  el.style.position = 'absolute';
  el.style.right = 'initial';
  el.style.left = '50%';
  el.style.transform = `translate(${getArrTopLeftShift()}px, -50%)`;
}

function getArrTopLeftShift() {
  const footerEl = document.querySelector('#footer');
  const footerContainerEl = footerEl.querySelector('.container');
  const containerWidth = footerContainerEl.getBoundingClientRect().width;
  const emptySpace = (window.innerWidth - containerWidth) / 2;
  const posLeft = containerWidth / 2;
  let result = null;

  if (emptySpace < 70) {
    result = window.innerWidth / 2 - 75;
  } else if (emptySpace > 260) {
    result = posLeft + 56;
  } else {
    result = posLeft + emptySpace / 2 - 30;
  }

  return result;
}

function addFooterObserver(el) {
  const arrTopEl = document.querySelector('[data-arr-top]');
  const options = {
    rootMargin: '20px',
  };

  const observer = new IntersectionObserver((entries, observer) => {
    if (entries[0].isIntersecting) {
      arrTopFooterStyles(arrTopEl);
      window.arrTopStickToFooter = true;
    } else {
      arrTopDefaultStyles(arrTopEl);
      window.arrTopStickToFooter = false;
    }
  }, options);

  observer.observe(el);
}

function addMapScripts() {
  const script1 = document.createElement('script');
  const script2 = document.createElement('script');

  script1.defer = true;
  script2.defer = true;

  script1.src =
    'https://api-maps.yandex.ru/2.1/?apikey=9e9fa8b4-3d73-4c40-9ab9-dc581593e696&lang=ru_RU';
  script2.src = 'assets/js/map.js';

  document.body.appendChild(script1);

  script1.addEventListener('load', () => document.body.appendChild(script2));
}
